import React from 'react';
import { Link } from 'react-router-dom';
import { CheckIcon, TargetIcon, ShieldCheckIcon, PackageIcon, ArrowRightIcon } from 'lucide-react';
import { Button } from '../components/ui/Button';
export function AboutPage() {
  return <main className="min-h-screen bg-dark-bg" data-id="element-493">
      {/* Hero */}
      <section className="py-16 md:py-20 bg-dark-surface border-b-2 border-dark-border" data-id="element-494">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-495">
          <h1 className="text-5xl md:text-6xl font-black text-white mb-6" data-id="element-496">
            O <span className="text-brand-yellow" data-id="element-497">D-TECH Solutions</span>
          </h1>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto" data-id="element-498">
            D-TECH Solutions je ovlašćeni uvoznik i distributer industrijskih
            sistema za transport tereta uz stepenice.
          </p>
        </div>
      </section>

      {/* O kompaniji */}
      <section className="py-14 md:py-16 border-b border-dark-border" data-id="element-499">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-500">
          <div className="space-y-5 text-lg text-gray-300 leading-relaxed mb-10" data-id="element-501">
            <p data-id="element-502">
              Specijalizovani smo za električne mašine za vertikalni transport
              namenjene profesionalnoj upotrebi u{' '}
              <span className="text-white font-semibold" data-id="element-503">
                građevini, logistici, skladištima i uslužnim delatnostima
              </span>
              .
            </p>
            <p data-id="element-504">
              Kao direktan uvoznik obezbeđujemo stabilne isporuke, kontrolisan
              kvalitet i lokalnu servisnu podršku.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-505">
            {['Stabilne isporuke', 'Kontrolisan kvalitet', 'Dostupne rezervne delove', 'Lokalnu servisnu podršku'].map(item => <div key={item} className="flex items-center gap-3 bg-dark-surface border border-dark-border rounded-xl px-5 py-4" data-id="element-506">
                <CheckIcon className="w-5 h-5 text-brand-yellow flex-shrink-0" data-id="element-507" />
                <span className="text-white font-medium" data-id="element-508">{item}</span>
              </div>)}
          </div>

          <p className="mt-8 text-gray-400 text-lg leading-relaxed" data-id="element-509">
            Naš cilj je jednostavan —{' '}
            <span className="text-white" data-id="element-510">
              da profesionalcima obezbedimo opremu koja radi pouzdano i bez
              zastoja.
            </span>
          </p>
        </div>
      </section>

      {/* Naša priča */}
      <section className="py-14 md:py-16 bg-dark-surface border-b border-dark-border" data-id="element-511">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-512">
          <h2 className="text-3xl md:text-4xl font-black text-white mb-6" data-id="element-513">
            Naša <span className="text-brand-yellow" data-id="element-514">priča</span>
          </h2>
          <div className="space-y-5 text-lg text-gray-300 leading-relaxed" data-id="element-515">
            <p data-id="element-516">
              Prepoznali smo potrebu tržišta za ozbiljnim, industrijskim
              rešenjem za transport tereta uz stepenice.
            </p>
            <p data-id="element-517">
              Zato smo uspostavili direktnu uvoznu liniju i servisnu mrežu kako
              bismo tržištu ponudili{' '}
              <span className="text-white font-semibold" data-id="element-518">
                sistem, a ne samo proizvod
              </span>
              .
            </p>
            <p data-id="element-519">
              D-TECH ne funkcioniše kao preprodaja bez podrške — već kao{' '}
              <span className="text-white font-semibold" data-id="element-520">
                brend sa kontrolom nabavke, rezervnih delova i postprodajne
                podrške
              </span>
              .
            </p>
          </div>
        </div>
      </section>

      {/* Misija i kvalitet */}
      <section className="py-14 md:py-16 border-b border-dark-border" data-id="element-521">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-522">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-523">
            <div className="bg-dark-surface border border-dark-border rounded-xl p-6" data-id="element-524">
              <div className="w-12 h-12 bg-brand-yellow/10 rounded-lg flex items-center justify-center mb-4" data-id="element-525">
                <TargetIcon className="w-6 h-6 text-brand-yellow" data-id="element-526" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-527">Naša misija</h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-528">
                Da obezbedimo siguran i efikasan transport tereta uz stepenice,
                uz smanjenje rizika, fizičkog napora i operativnih zastoja.
              </p>
            </div>

            <div className="bg-dark-surface border border-dark-border rounded-xl p-6" data-id="element-529">
              <div className="w-12 h-12 bg-brand-yellow/10 rounded-lg flex items-center justify-center mb-4" data-id="element-530">
                <ShieldCheckIcon className="w-6 h-6 text-brand-yellow" data-id="element-531" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-532">
                Kvalitet i podrška
              </h3>
              <p className="text-gray-400 leading-relaxed mb-4" data-id="element-533">
                Svaka jedinica dolazi uz jasne uslove garancije i tehničku
                podršku. Kao uvoznik, stojimo iza svake isporučene jedinice.
              </p>
              <ul className="space-y-2" data-id="element-534">
                {['Obezbeđeni rezervni delovi', 'Tehnička podrška', 'Servisna mreža u Srbiji', 'Jasni uslovi garancije'].map(item => <li key={item} className="flex items-center gap-2 text-sm text-gray-300" data-id="element-535">
                    <CheckIcon className="w-4 h-4 text-brand-yellow flex-shrink-0" data-id="element-536" />
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="bg-dark-surface border border-dark-border rounded-xl p-6" data-id="element-537">
              <div className="w-12 h-12 bg-brand-yellow/10 rounded-lg flex items-center justify-center mb-4" data-id="element-538">
                <PackageIcon className="w-6 h-6 text-brand-yellow" data-id="element-539" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-540">
                Direktan uvoz
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-541">
                Direktna uvozna linija znači kraće rokove isporuke, stabilne
                cene i kontrolu svakog segmenta — od narudžbine do postprodajne
                podrške.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-14 md:py-16 bg-dark-surface border-t border-dark-border" data-id="element-542">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-543">
          <h2 className="text-3xl md:text-4xl font-black text-white mb-4" data-id="element-544">
            Radimo <span className="text-brand-yellow" data-id="element-545">zajedno</span>
          </h2>
          <p className="text-lg text-gray-400 mb-8" data-id="element-546">
            Spremni da poboljšate svoje operacije sa pouzdanom industrijskom
            opremom?
          </p>
          <Link to="/contact" data-id="element-547">
            <Button variant="primary" size="lg" data-id="element-548">
              Kontaktirajte nas
              <ArrowRightIcon className="w-5 h-5 ml-2 inline" data-id="element-549" />
            </Button>
          </Link>
        </div>
      </section>
    </main>;
}